<p-toast></p-toast>
<div class="p-5 bg-white">
  <p-table
    [value]="bookings"
    [lazy]="true"
    (onLazyLoad)="handleLazyLoad($event)"
    [paginator]="true"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [first]="query.skip"
    [rows]="query.take"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    paginatorStyleClass="paginator-left"
  >
    <ng-template pTemplate="caption">
      <div class="flex justify-content-between align-items-center mb-3">
        <h2 class="text-xl font-bold m-0">Tour Operator Bookings</h2>

        <div class="flex gap-2 align-items-center">
          <p-calendar [(ngModel)]="filter.startDate" 
            (onSelect)="handleFilterChange()"
            (onClear)="handleFilterChange()"
            placeholder="From:" 
            [showIcon]="true"
            [showClear]="true"
            dateFormat="mm/dd/yy"></p-calendar>

          <p-calendar [(ngModel)]="filter.endDate" 
            (onSelect)="handleFilterChange()"
            (onClear)="handleFilterChange()"
            placeholder="To:" 
            [showIcon]="true"
            [showClear]="true"
            dateFormat="mm/dd/yy"></p-calendar>

          <p-button label="Export" icon="pi pi-download" (click)="openExportSidebar()" />
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Id">Booking ID<p-sortIcon field="Id"/></th>
        <th pSortableColumn="CustomerName">Customer Name<p-sortIcon field="CustomerName"/></th>
        <th pSortableColumn="TourName">Activity<p-sortIcon field="TourName"/></th>
        <th pSortableColumn="OperatorName">Operator<p-sortIcon field="OperatorName"/></th>
        <th pSortableColumn="ScheduledAt">Activity Date<p-sortIcon field="ScheduledAt"/></th>
        <th pSortableColumn="GuestCount">Guest<p-sortIcon field="GuestCount"/></th>
        <th pSortableColumn="Amount">Amount<p-sortIcon field="Amount"/></th>
        <th pSortableColumn="RedeemedText">Redeemed<p-sortIcon field="RedeemedText"/></th>
        <th pSortableColumn="Status">Status<p-sortIcon field="Status"/></th>
        <th *ngIf="appData.xpressUserRoleId === XpressUserRoleEnum.Admin">Action</th>
      </tr>
      <tr>
        <th>
          <input
            type="number"
            class="p-inputtext p-component"
            [(ngModel)]="filter.id"
            (ngModelChange)="handleFilterChange()"
            placeholder="Type here"/>
        </th>
        <th>
          <input
            type="text"
            class="p-inputtext p-component"
            [(ngModel)]="filter.customerName"
            (ngModelChange)="handleFilterChange()"
            placeholder="Type here"/>
        </th>
        <th>
            <input
            type="text"
            class="p-inputtext p-component"
            [(ngModel)]="filter.tourName"
            (ngModelChange)="handleFilterChange()"
            placeholder="Type here"/>
        </th>
        <th>
            <input
            type="text"
            class="p-inputtext p-component"
            [(ngModel)]="filter.operatorName"
            (ngModelChange)="handleFilterChange()"
            placeholder="Type here"/>
        </th>
        <th>
            <p-calendar
            [showIcon]="true"
            placeholder="Select Date"
            dateFormat="mm/dd/yy"
            [(ngModel)]="filter.scheduledAt"
            [showClear]="true"
            (onSelect)="handleFilterChange()"
            (onClear)="handleFilterChange()"/>
        </th>
        <th>
            <input
            type="number"
            class="p-inputtext p-component"
            [(ngModel)]="filter.guestCount"
            (ngModelChange)="handleFilterChange()"
            placeholder="Type here"/>
        </th>
        <th>
            <input
            type="number"
            class="p-inputtext p-component"
            [(ngModel)]="filter.amount"
            (ngModelChange)="handleFilterChange()"
            placeholder="Type here"/>
        </th>
        <th>
          <p-dropdown
            [(ngModel)]="filter.redeemed"
            [options]="['Yes', 'No']"
            (onChange)="handleFilterChange()"
            placeholder="Select"
            [showClear]="true">
          </p-dropdown>
        </th>
        <th>
          <p-dropdown
            [(ngModel)]="filter.status"
            [options]="statuses"
            (onChange)="handleFilterChange()"
            placeholder="Select"
            [showClear]="true"
            optionLabel="Name"
            optionValue="Id">
          </p-dropdown>
        </th>
        <th *ngIf="appData.xpressUserRoleId === XpressUserRoleEnum.Admin"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-order>
      <tr class="black-color cursor-pointer" (click)="onRowClick(order.Id)">
        <td>{{ order.Id }}</td>
        <td>{{ order.CustomerName }}</td>
        <td>{{ order.TourName }}</td>
        <td>{{ order.OperatorName }}</td>
        <td>{{ order.ScheduledAt }}</td>
        <td>{{ order.GuestCount }}</td>
        <td>₱{{ order.Amount }}</td>
        <td>
            <span class="status-booking" [ngClass]="{'redeem-yes': order.Redeemed, 'redeem-no': !order.Redeemed }">
                {{order.RedeemedText}}
            </span>
        </td>
        <td><span class="status-booking" [class]="order.Status?.toLowerCase()">{{order.Status}}</span></td>
        <td *ngIf="appData.xpressUserRoleId === XpressUserRoleEnum.Admin" (click)="$event.stopPropagation()">
              <p-dropdown
                  [options]="statuses"
                  optionLabel="Name"
                  (onChange)="updateStatus($event.value, order)"
                  placeholder="Select Status"
                  [showClear]="false">
              </p-dropdown>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="100%">
          <div class="empty-message">
            <img src="/XpressApp/assets/images/xpass/no-match.svg" />
            <p>We didn't find a match</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="summary">In total there are {{ totalRecords }} Bookings.</div>
</div>

<p-sidebar [(visible)]="showExportSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="changedVisibleExportSidebar(false)"
           [style]="{width:'580px'}">
    <ng-template pTemplate="header">Export data</ng-template>

    <div class="flex flex-column mt-2">
        <label class="export-data-label mb-2">File Type</label>
        <p-dropdown [options]="exportFileTypes" placeholder="Please Select" optionLabel="name" optionValue="value" [(ngModel)]="exportData.fileType"></p-dropdown>
    </div>
    <div class="flex justify-content-end mt-4" *ngIf="!exportLoading">
        <button class="btn-darkblue" pButton label="Download" (click)="export()"></button>
    </div>
</p-sidebar>

<p-dialog
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [resizable]="false"
        [(visible)]="exportLoading"
        [style]="{ width: '425px', height: '215px' }">
    <ng-template pTemplate="header">
        <div class="text-center">Exporting...</div>
    </ng-template>
    <div class="text-center">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="4" fill="transparent" animationDuration=".5s"></p-progressSpinner>
        <p class="mt-3">Please wait while we prepare your file...</p>
    </div>
</p-dialog>
